import { ClipTypeEnum, Engine } from "@rendley/sdk";
import { TypeIcon } from "../../../assets/icons/TypeIcon";
import { FiltersIcon } from "../../../assets/icons/FiltersIcon";
import { SlidersIcon } from "../../../assets/icons/SlidersIcon";
import { LayersIcon } from "../../../assets/icons/LayersIcon";
import { t } from "../../../utils/translation";
import EditTextPanel from "../../../../editor/modules/edit-panel/containers/EditTextPanel/EditTextPanel";
import { JSX } from "react";
//import EditLottiePanel from "../../sidebar/containers/EditLottiePanelContainer/EditLottiePanelContainer";

export interface SidebarStep {
  title: string;
  subtitle?: string;
  icon?: () => JSX.Element;
  content: () => JSX.Element;
}

export enum SidebarStepEnum {
  EDIT_TEXT = "edit_text",
  EDIT_LOTTIE = "edit_lottie",
  FILTERS = "filters",
  SUBTITLES_STYLE = "subtitles_style",
  SUBTITLES_PRESETS = "subtitles_presets",
}

// @ts-ignore
export const RightSidebarSteps: Record<SidebarStepEnum, SidebarStep> = {
  [SidebarStepEnum.EDIT_TEXT]: {
    title: t("common.edit", "Edit"),
    icon: TypeIcon,
    // @ts-ignore
    content: () => <EditTextPanel/>,
  },
  // [SidebarStepEnum.EDIT_LOTTIE]: {
  //   title: t("common.edit", "Edit"),
  //   icon: TypeIcon,
  //   content: () => <EditLottiePanel/>,
  // },
  // [SidebarStepEnum.FILTERS]: {
  //   title: t("common.filters", "Filters"),
  //   icon: FiltersIcon,
  //   content: () => ,
  // },
  // [SidebarStepEnum.SUBTITLES_STYLE]: {
  //   title: t("common.styles", "Styles"),
  //   icon: SlidersIcon,
  //   content: () => <ve-subtitles-styles-container />,
  // },
  // [SidebarStepEnum.SUBTITLES_PRESETS]: {
  //   title: t("common.presets", "Presets"),
  //   icon: LayersIcon,
  //   content: () => <ve-subtitles-presets-container />,
  // },
};

export const getStepsOrderByClipId = (clipId: string | null) => {
  if (!clipId) {
    return [];
  }

  const clipType = Engine.getInstance().getClipById(clipId)?.getType() as ClipTypeEnum;

  if (!clipType) {
    return [];
  }

  switch (clipType) {
    case ClipTypeEnum.TEXT:
      return [SidebarStepEnum.EDIT_TEXT, SidebarStepEnum.FILTERS];
    case ClipTypeEnum.IMAGE:
    case ClipTypeEnum.GIF:
    case ClipTypeEnum.VIDEO:
      return [SidebarStepEnum.FILTERS];
    case ClipTypeEnum.LOTTIE:
      return [SidebarStepEnum.EDIT_LOTTIE, SidebarStepEnum.FILTERS];
    case ClipTypeEnum.SUBTITLES:
      return [SidebarStepEnum.SUBTITLES_PRESETS, SidebarStepEnum.SUBTITLES_STYLE];
    case ClipTypeEnum.AUDIO:
    default:
      return [];
  }
};
